'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _format = require('../../helpers/format');

var _format2 = _interopRequireDefault(_format);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _ = require('../');

var _reactModal = require('react-modal');

var _reactModal2 = _interopRequireDefault(_reactModal);

var _PlanScorecardResultModal = require('./PlanScorecardResultModal.css');

var _PlanScorecardResultModal2 = _interopRequireDefault(_PlanScorecardResultModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlanScorecardResultModal = (_dec = (0, _reactCssModules2.default)(_PlanScorecardResultModal2.default, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(PlanScorecardResultModal, _Component);

  function PlanScorecardResultModal(props) {
    (0, _classCallCheck3.default)(this, PlanScorecardResultModal);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PlanScorecardResultModal.__proto__ || (0, _getPrototypeOf2.default)(PlanScorecardResultModal)).call(this, props));

    _this.openModal = function () {
      _this.setState({ modalOpen: true });
    };

    _this.closeModal = function () {
      _this.setState({ modalOpen: false });
    };

    _this.state = {
      modalOpen: false
    };
    return _this;
  }

  (0, _createClass3.default)(PlanScorecardResultModal, [{
    key: 'render',
    value: function render() {
      if (!this.props.iyv || !this.props.fund) {
        return null;
      }

      var companies = [];

      var redOctagon = _react2.default.createElement(
        'div',
        { styleName: 'result-shape-txt-wrap' },
        _react2.default.createElement(
          'div',
          { styleName: 'result-shape-wrap' },
          _react2.default.createElement('div', { title: 'Poor', styleName: 'red-octagon' })
        )
      );
      var yellowSquare = _react2.default.createElement(
        'div',
        { styleName: 'result-shape-txt-wrap' },
        _react2.default.createElement(
          'div',
          { styleName: 'result-shape-wrap' },
          _react2.default.createElement('div', { title: 'Fair', styleName: 'yellow-square' })
        )
      );
      var greenCircle = _react2.default.createElement(
        'div',
        { styleName: 'result-shape-txt-wrap' },
        _react2.default.createElement(
          'div',
          { styleName: 'result-shape-wrap' },
          _react2.default.createElement('div', { title: 'Good', styleName: 'green-circle' })
        )
      );

      var headline = '';
      var description = '';
      var iconSrc = null;
      var iconAlt = '';
      var shape = null;
      var url = '';

      var _props = this.props,
          fund = _props.fund,
          notPlan = _props.notPlan;
      var strategy_name = fund.strategy_name;

      var sStrategy = _format2.default.sanitize(strategy_name);

      var highlighted_holdings = null;
      if (fund.highlighted_holdings) {
        highlighted_holdings = fund.highlighted_holdings;
      } else {
        var td = _config2.default.targetDateSeries.find(function (series) {
          return series.strategy_name_query === sStrategy;
        });
        highlighted_holdings = td.highlighted_holdings;
      }

      var grade_bracket_text = function grade_bracket_text(grade) {
        if (grade === 4 || grade === 5) {
          return 'D or F grades';
        } else if (grade === 2 || grade === 3) {
          return 'B or C grades';
        } else if (grade === 1) {
          return 'an A grade';
        }
        return 'Err';
      };

      var rating_bracket_text = function rating_bracket_text(grade) {
        if (grade === 4 || grade === 5) {
          return 'poor';
        } else if (grade === 2 || grade === 3) {
          return 'fair';
        } else if (grade === 1) {
          return 'good';
        }
        return 'Err';
      };

      var rating_bracket_shape = function rating_bracket_shape(grade) {
        if (grade === 4 || grade === 5) {
          return redOctagon;
        } else if (grade === 2 || grade === 3) {
          return yellowSquare;
        } else if (grade === 1) {
          return greenCircle;
        }
        return null;
      };

      var leadSentence = _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'p',
          null,
          notPlan ? _react2.default.createElement(
            'span',
            null,
            'If your retirement plan offers the ',
            _react2.default.createElement(
              'b',
              null,
              strategy_name,
              ':'
            )
          ) : _react2.default.createElement(
            'span',
            null,
            'The target date option for this retirement plan is the ',
            _react2.default.createElement(
              'b',
              null,
              strategy_name,
              '.'
            )
          )
        )
      );

      var tryToGetLogo = function tryToGetLogo(_e) {
        var logo = null;
        try {
          logo = require('../../../static/images/cos/' + _format2.default.sanitize(_e) + '.png');
        } catch (_err) {
          console.log('');
        }
        return logo;
      };

      switch (this.props.iyv) {
        //
        //
        //
        case 'fff':
          headline = _react2.default.createElement(
            'div',
            null,
            'The target date option 2050 fund is ',
            _react2.default.createElement(
              'span',
              { styleName: rating_bracket_text(fund.grade_fossil) },
              _format2.default.perc(fund.ff_all_weight, false, 1)
            ),
            ' invested in fossil fuel companies.'
          );
          description = _react2.default.createElement(
            'div',
            null,
            leadSentence,
            _react2.default.createElement(
              'p',
              null,
              'Using the 2050 fund to represent the series, we found ',
              _react2.default.createElement(
                'b',
                null,
                _format2.default.perc(fund.ff_all_weight),
                ' invested in fossil fuel companies'
              ),
              ', including ',
              _react2.default.createElement(
                'b',
                null,
                _format2.default.perc(fund.c2_weight, false, 1)
              ),
              ' in the top 200 carbon reserve owners, and ',
              _react2.default.createElement(
                'b',
                null,
                _format2.default.perc(fund.mc50_weight, false, 1)
              ),
              ' in the top 30 coal-fired utilities.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'This is assigned a ',
              _react2.default.createElement(
                'b',
                null,
                'fossil fuel grade of ',
                _format2.default.score(fund.grade_fossil),
                '.'
              ),
              ' When a retirement plan target date option is assigned ',
              grade_bracket_text(fund.grade_fossil),
              ', we rate that as ',
              _react2.default.createElement(
                'b',
                null,
                rating_bracket_text(fund.grade_fossil),
                '.'
              )
            )
          );
          iconSrc = require('../../../static/images/icons/fff-icon-white.svg');
          iconAlt = 'Fossil fuels';
          shape = rating_bracket_shape(fund.grade_fossil);
          companies = highlighted_holdings.fff.map(function (e, i) {
            return [tryToGetLogo(e), e];
          });
          url = _config2.default.routes.targetDateFunds + '/' + sStrategy + '?issue=fossil';
          break;
        //
        //
        //
        case 'ffb':
          headline = _react2.default.createElement(
            'div',
            null,
            'The target date option 2050 fund has a score of ',
            _react2.default.createElement(
              'span',
              { styleName: rating_bracket_text(fund.grade_fossil_bank) },
              _format2.default.number(fund.fossil_bank_score, false, false, 2)
            ),
            ' for fossil fuel finance.'
          );
          description = _react2.default.createElement(
            'div',
            null,
            leadSentence,
            _react2.default.createElement(
              'p',
              null,
              'Using the 2050 fund to represent the series, the fund has a score of ',
              _react2.default.createElement(
                'b',
                null,
                _format2.default.number(fund.fossil_bank_score, false, false, 2),
                ' for fossil fuel finance.'
              )
            ),
            _react2.default.createElement(
              'p',
              null,
              'This is assigned a ',
              _react2.default.createElement(
                'b',
                null,
                'fossil fuel finance grade of ',
                _format2.default.score(fund.grade_fossil_bank),
                '.'
              ),
              ' When a retirement plan target date option is assigned ',
              grade_bracket_text(fund.grade_fossil_bank),
              ', we rate that as ',
              _react2.default.createElement(
                'b',
                null,
                rating_bracket_text(fund.grade_fossil_bank),
                '.'
              )
            )
          );
          iconSrc = require('../../../static/images/icons/ffb-icon-white.svg');
          iconAlt = 'Fossil fuel finance';
          shape = rating_bracket_shape(fund.grade_fossil_bank);
          companies = highlighted_holdings.ffb.map(function (e, i) {
            return [tryToGetLogo(e), e];
          });
          url = _config2.default.routes.targetDateFunds + '/' + sStrategy + '?issue=fossil-fuel-lending';
          break;
        //
        //
        //
        case 'ffi':
          headline = _react2.default.createElement(
            'div',
            null,
            'The target date option 2050 fund has a score of ',
            _react2.default.createElement(
              'span',
              { styleName: rating_bracket_text(fund.grade_fossil_insure) },
              _format2.default.number(fund.fossil_insure_score, false, false, 2)
            ),
            ' for fossil fuel insurance.'
          );
          description = _react2.default.createElement(
            'div',
            null,
            leadSentence,
            _react2.default.createElement(
              'p',
              null,
              'Using the 2050 fund to represent the series, the fund has a score of ',
              _react2.default.createElement(
                'b',
                null,
                _format2.default.number(fund.fossil_insure_score, false, false, 2),
                ' for fossil fuel insurance.'
              )
            ),
            _react2.default.createElement(
              'p',
              null,
              'This is assigned a ',
              _react2.default.createElement(
                'b',
                null,
                'fossil fuel insurance grade of ',
                _format2.default.score(fund.grade_fossil_insure),
                '.'
              ),
              ' When a retirement plan target date option is assigned ',
              grade_bracket_text(fund.grade_fossil_insure),
              ', we rate that as ',
              _react2.default.createElement(
                'b',
                null,
                rating_bracket_text(fund.grade_fossil_insure),
                '.'
              )
            )
          );
          iconSrc = require('../../../static/images/icons/ffi-icon-white.svg');
          iconAlt = 'Fossil fuel insurance';
          shape = rating_bracket_shape(fund.grade_fossil_insure);
          companies = highlighted_holdings.ffi.map(function (e, i) {
            return [tryToGetLogo(e), e];
          });
          url = _config2.default.routes.targetDateFunds + '/' + sStrategy + '?issue=fossil-fuel-insurance';
          break;
        //
        //
        //
        case 'dff':
          headline = _react2.default.createElement(
            'div',
            null,
            'The target date option 2050 fund is ',
            _react2.default.createElement(
              'span',
              { styleName: rating_bracket_text(fund.grade_deforestation) },
              _format2.default.perc(fund.df_p_weight, false, 1)
            ),
            ' invested in deforestation-risk agribusiness producer/traders.'
          );
          description = _react2.default.createElement(
            'div',
            null,
            leadSentence,
            _react2.default.createElement(
              'p',
              null,
              'Using the 2050 fund to represent the series, we found ',
              _react2.default.createElement(
                'b',
                null,
                _format2.default.perc(fund.df_p_weight),
                ' invested in deforestation-risk agribusiness producer/traders.'
              )
            ),
            _react2.default.createElement(
              'p',
              null,
              'This is assigned a ',
              _react2.default.createElement(
                'b',
                null,
                'deforestation grade of ',
                _format2.default.score(fund.grade_deforestation),
                '.'
              ),
              ' When a retirement plan target date option is assigned ',
              grade_bracket_text(fund.grade_deforestation),
              ', we rate that as ',
              _react2.default.createElement(
                'b',
                null,
                rating_bracket_text(fund.grade_deforestation),
                '.'
              )
            )
          );
          iconSrc = require('../../../static/images/icons/dff-icon-white.svg');
          iconAlt = 'Deforestation';
          shape = rating_bracket_shape(fund.grade_deforestation);
          companies = highlighted_holdings.dff.map(function (e, i) {
            return [tryToGetLogo(e), e];
          });
          url = _config2.default.routes.targetDateFunds + '/' + sStrategy + '?issue=deforestation';
          break;
        //
        //
        //
        case 'gef':
          headline = _react2.default.createElement(
            'div',
            null,
            'The target date option 2050 fund is ranked at the ',
            _react2.default.createElement(
              'span',
              { styleName: rating_bracket_text(fund.grade_gender_equality) },
              _format2.default.gefScore(fund.gef_grp_norm),
              'th percentile'
            ),
            ' on gender equality.'
          );
          description = _react2.default.createElement(
            'div',
            null,
            leadSentence,
            _react2.default.createElement(
              'p',
              null,
              'Using the 2050 fund to represent the series, we calculated a ',
              _react2.default.createElement(
                'b',
                null,
                'gender equality score of ',
                _format2.default.gefScore(fund.gef_score),
                ' / 100'
              ),
              ' using the Equileap gender equality corporate scorecard. This ranks at the ',
              _react2.default.createElement(
                'b',
                null,
                _format2.default.gefScore(fund.gef_grp_norm),
                'th percentile'
              ),
              ' for the Allocation Funds group.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'This is assigned a ',
              _react2.default.createElement(
                'b',
                null,
                'gender equality grade of ',
                _format2.default.score(fund.grade_gender_equality),
                '.'
              ),
              ' When a retirement plan target date option is assigned ',
              grade_bracket_text(fund.grade_gender_equality),
              ', we rate that as ',
              _react2.default.createElement(
                'b',
                null,
                rating_bracket_text(fund.grade_gender_equality),
                '.'
              )
            )
          );
          iconSrc = require('../../../static/images/icons/gef-icon-white.svg');
          iconAlt = 'Gender equality';
          shape = rating_bracket_shape(fund.grade_gender_equality);
          url = _config2.default.routes.targetDateFunds + '/' + sStrategy + '?issue=gender-equality';
          break;
        //
        //
        //
        case 'gff':
          headline = _react2.default.createElement(
            'div',
            null,
            'The target date option 2050 fund is ',
            _react2.default.createElement(
              'span',
              { styleName: rating_bracket_text(fund.grade_guns) },
              _format2.default.perc(fund.wff_gun_manufacturers_weight)
            ),
            ' invested in gun manufacturers.'
          );
          description = _react2.default.createElement(
            'div',
            null,
            leadSentence,
            _react2.default.createElement(
              'p',
              null,
              'Using the 2050 fund to represent the series, we found ',
              _react2.default.createElement(
                'b',
                null,
                _format2.default.perc(fund.wff_gun_manufacturers_weight),
                ' invested in civilian firearm manufacturers'
              ),
              ' and ',
              _react2.default.createElement(
                'b',
                null,
                _format2.default.perc(fund.wff_gun_retailers_weight)
              ),
              ' invested in firearm retailers.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'This is assigned a ',
              _react2.default.createElement(
                'b',
                null,
                'civilian firearm grade of ',
                _format2.default.score(fund.grade_guns),
                '.'
              ),
              ' When a retirement plan target date option is assigned ',
              grade_bracket_text(fund.grade_guns),
              ', we rate that as ',
              _react2.default.createElement(
                'b',
                null,
                rating_bracket_text(fund.grade_guns),
                '.'
              )
            )
          );
          iconSrc = require('../../../static/images/icons/gff-icon-white.svg');
          iconAlt = 'Civilian firearms';
          shape = rating_bracket_shape(fund.grade_guns);
          companies = highlighted_holdings.gff.map(function (e, i) {
            return [tryToGetLogo(e), e];
          });
          url = _config2.default.routes.targetDateFunds + '/' + sStrategy + '?issue=guns';
          break;
        //
        //
        //
        case 'pff':
          headline = _react2.default.createElement(
            'div',
            null,
            'The target date option 2050 fund is ',
            _react2.default.createElement(
              'span',
              { styleName: rating_bracket_text(fund.grade_prison_industrial_complex) },
              _format2.default.perc(fund.pff_high_weight, false, 1)
            ),
            ' invested in high-risk prison and border industry companies.'
          );
          description = _react2.default.createElement(
            'div',
            null,
            leadSentence,
            _react2.default.createElement(
              'p',
              null,
              'Using the 2050 fund to represent the series, we found ',
              _react2.default.createElement(
                'b',
                null,
                _format2.default.perc(fund.pff_high_weight),
                ' invested in companies with a high risk of involvement in the prison industrial complex'
              ),
              ', including ',
              _react2.default.createElement(
                'b',
                null,
                _format2.default.perc(fund.pff_extreme_weight)
              ),
              ' in private prison operators.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'This is assigned a ',
              _react2.default.createElement(
                'b',
                null,
                'prison industrial complex grade of ',
                _format2.default.score(fund.grade_prison_industrial_complex),
                '.'
              ),
              ' When a retirement plan target date option is assigned ',
              grade_bracket_text(fund.grade_prison_industrial_complex),
              ', we rate that as ',
              _react2.default.createElement(
                'b',
                null,
                rating_bracket_text(fund.grade_prison_industrial_complex),
                '.'
              )
            )
          );
          iconSrc = require('../../../static/images/icons/pff-icon-white.svg');
          iconAlt = 'Prison industrial complex';
          shape = rating_bracket_shape(fund.grade_prison_industrial_complex);
          companies = highlighted_holdings.pff.map(function (e, i) {
            return [tryToGetLogo(e), e];
          });
          url = _config2.default.routes.targetDateFunds + '/' + sStrategy + '?issue=prison-industrial-complex';
          break;
        //
        //
        //
        case 'wff':
          headline = _react2.default.createElement(
            'div',
            null,
            'The target date option 2050 fund is ',
            _react2.default.createElement(
              'span',
              { styleName: rating_bracket_text(fund.grade_military) },
              _format2.default.perc(fund.wff_mil_weight, false, 1)
            ),
            ' invested in arms manufacturers and military contractors.'
          );
          description = _react2.default.createElement(
            'div',
            null,
            leadSentence,
            _react2.default.createElement(
              'p',
              null,
              'Using the 2050 fund to represent the series, we found ',
              _react2.default.createElement(
                'b',
                null,
                _format2.default.perc(fund.wff_mil_weight),
                ' invested in arms manufacturers and military contractors'
              ),
              ', including ',
              _react2.default.createElement(
                'b',
                null,
                _format2.default.perc(fund.wff_nuclear_weapons_weight)
              ),
              ' in companies flagged for involvement with nuclear weapons, and ',
              _react2.default.createElement(
                'b',
                null,
                _format2.default.perc(fund.wff_cluster_munitions_weight)
              ),
              ' in companies flagged involvement with controversial weapons like cluster munitions, anti-personnel landmines, incendiary weapons, and depleted uranium.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'This is assigned a ',
              _react2.default.createElement(
                'b',
                null,
                'military weapons grade of ',
                _format2.default.score(fund.grade_military),
                '.'
              ),
              ' When a retirement plan target date option is assigned ',
              grade_bracket_text(fund.grade_military),
              ', we rate that as ',
              _react2.default.createElement(
                'b',
                null,
                rating_bracket_text(fund.grade_military),
                '.'
              )
            )
          );
          iconSrc = require('../../../static/images/icons/wff-icon-white.svg');
          iconAlt = 'Military weapons';
          shape = rating_bracket_shape(fund.grade_military);
          companies = highlighted_holdings.wff.map(function (e, i) {
            return [tryToGetLogo(e), e];
          });
          url = _config2.default.routes.targetDateFunds + '/' + sStrategy + '?issue=military-weapons';
          break;
        //
        //
        //
        case 'tff':
          headline = _react2.default.createElement(
            'div',
            null,
            'The target date option 2050 fund is ',
            _react2.default.createElement(
              'span',
              { styleName: rating_bracket_text(fund.grade_tobacco) },
              _format2.default.perc(fund.t_weight, false, 1)
            ),
            ' invested in tobacco companies.'
          );
          description = _react2.default.createElement(
            'div',
            null,
            leadSentence,
            _react2.default.createElement(
              'p',
              null,
              'Using the 2050 fund to represent the series, we found ',
              _react2.default.createElement(
                'b',
                null,
                _format2.default.perc(fund.t_weight),
                ' invested in tobacco companies'
              ),
              fund.t_m_weight > 0 && fund.t_weight === 0 ? _react2.default.createElement(
                'span',
                null,
                '\xA0and ',
                _react2.default.createElement(
                  'b',
                  null,
                  _format2.default.perc(fund.t_m_weight)
                ),
                ' invested in tobacco-promoting entertainment studios'
              ) : null,
              '.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'This is assigned a ',
              _react2.default.createElement(
                'b',
                null,
                'tobacco grade of ',
                _format2.default.score(fund.grade_tobacco),
                '.'
              ),
              ' When a retirement plan target date option is assigned ',
              grade_bracket_text(fund.grade_tobacco),
              ', we rate that as ',
              _react2.default.createElement(
                'b',
                null,
                rating_bracket_text(fund.grade_tobacco),
                '.'
              )
            )
          );
          iconSrc = require('../../../static/images/icons/tff-icon-white.svg');
          iconAlt = 'Tobacco';
          shape = rating_bracket_shape(fund.grade_tobacco);
          companies = highlighted_holdings.tff.map(function (e, i) {
            return [tryToGetLogo(e), e];
          });
          url = _config2.default.routes.targetDateFunds + '/' + sStrategy + '?issue=tobacco';
          break;
        //
        //
        //
        default:
          break;
      }

      return _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement(
          'span',
          { onClick: this.openModal, styleName: 'modal-opener' },
          this.props.children
        ),
        _react2.default.createElement(
          _reactModal2.default,
          {
            isOpen: this.state.modalOpen,
            onRequestClose: this.closeModal,
            contentLabel: 'Company profile',
            style: {
              overlay: {
                backgroundColor: 'rgba(0, 0, 0, 0.75)'
              },
              content: {
                position: 'absolute',
                top: '50%',
                left: 0,
                right: 0,
                bottom: 'auto',
                marginLeft: 'auto',
                marginRight: 'auto',
                width: '1000px',
                maxWidth: '90%',
                border: '0px',
                background: '#fff',
                overflow: 'visible',
                WebkitOverflowScrolling: 'touch',
                borderRadius: 0,
                outline: 'none',
                transform: 'translateY(-50%)',
                padding: 0
              }
            } },
          _react2.default.createElement(
            'div',
            { styleName: 'family-modal-wrap' },
            _react2.default.createElement(
              'div',
              { styleName: 'family-modal-flex' },
              _react2.default.createElement(
                'div',
                { styleName: 'family-modal-img img-' + this.props.iyv },
                _react2.default.createElement(
                  'div',
                  { styleName: 'family-modal-img-gray' },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'family-modal-header' },
                    _react2.default.createElement(
                      'div',
                      { styleName: 'result-lbl-icon-bbl' },
                      _react2.default.createElement('img', { styleName: 'result-lbl-icon', src: iconSrc, alt: iconAlt })
                    ),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'result-modal-img-headline' },
                      headline
                    )
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'family-modal' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'icons-row-bbl-shape' },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'result-lbl' },
                    iconAlt,
                    ' rating'
                  ),
                  shape
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'family-modal-p' },
                  description
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'icons-row' },
                  companies.length > 0 ? _react2.default.createElement(
                    'div',
                    { styleName: 'company-logos-wrap' },
                    _react2.default.createElement(
                      'span',
                      { style: {
                          whiteSpace: 'nowrap',
                          width: '100%',
                          textAlign: 'left'
                        } },
                      'Invested in:\xA0'
                    ),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'company-logos' },
                      companies.map(function (e, i) {
                        if (e[0]) {
                          return _react2.default.createElement(
                            'div',
                            {
                              key: 'company-logo-' + i,
                              styleName: 'company-logo'
                            },
                            _react2.default.createElement('img', {
                              src: e[0],
                              alt: e[1]
                            })
                          );
                        }
                        return _react2.default.createElement(
                          'div',
                          {
                            key: 'company-logo-' + i,
                            styleName: 'company-no-logo'
                          },
                          e[1]
                        );
                      })
                    )
                  ) : _react2.default.createElement('div', null)
                ),
                notPlan ? null : _react2.default.createElement(
                  'div',
                  { styleName: 'more-link' },
                  _react2.default.createElement(
                    _.Link,
                    {
                      to: url,
                      title: iconAlt + ' results',
                      xstrong: true
                    },
                    'More results for ',
                    strategy_name
                  )
                )
              )
            ),
            _react2.default.createElement(
              'div',
              {
                styleName: 'family-modal-close-wrap',
                onClick: this.closeModal
              },
              _react2.default.createElement('div', {
                styleName: 'family-modal-close',
                className: 'fa fa-times'
              })
            )
          )
        )
      );
    }
  }]);
  return PlanScorecardResultModal;
}(_react.Component), _class2.propTypes = {
  iyv: _react.PropTypes.string,
  fund: _react.PropTypes.object,
  notPlan: _react.PropTypes.bool
}, _temp)) || _class);
exports.default = PlanScorecardResultModal;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PlanScorecardResultModal/PlanScorecardResultModal.js
// module id = 1424
// module chunks = 0